import { defineMessages } from 'react-intl';

export const statuses = defineMessages({
  alreadyEarned: {
    id: 'chatbot.status.alreadyEarned',
    defaultMessage: 'You have already earned this badge.',
  },
});

export const labels = defineMessages({
  loading: {
    id: 'chatbot.label.loading',
    defaultMessage: 'Loading',
  },
  getThisBadge: {
    id: 'chatbot.label.getThisBadge',
    defaultMessage: 'Take Our Quiz',
  },
  startQuizbot: {
    id: 'chatbot.label.startQuizbot',
    defaultMessage: 'Start Chatbot',
  },
  alreadyEarned: {
    id: 'chatbot.label.alreadyEarned',
    defaultMessage: 'You already have it!',
  },
});
